/** Matches server `buildChooseFeedbackTypesQuestion` title prefix (after optional leading newline/space). */
export const QUESTION_FEEDBACK_TYPES_PREFIX = "Select manuscript feedback types";

/** Sent when Skip / Cancel / Esc dismisses without substantive choice (`AskUserQuestion` emitSkip). */
export const USER_QUESTION_NO_PREFERENCE = "[No preference]";

/** Must match SilentFeedbackMarkers in questionnaire UI (prepend of stored reply when Done submits types). */
export const SILENT_FEEDBACK_TYPES_SUBMISSION_MARKER =
  "__SW_SILENT_FEEDBACK_TYPES_SUBMISSION__\n";

export function prependSilentFeedbackTypesSubmissionMarker(questionAnswerBlock: string): string {
  return `${SILENT_FEEDBACK_TYPES_SUBMISSION_MARKER}${questionAnswerBlock}`;
}

export function isSilentFeedbackTypesPickerSubmission(message: string): boolean {
  return typeof message === "string" && message.startsWith(SILENT_FEEDBACK_TYPES_SUBMISSION_MARKER);
}

/** For titles and display: remove internal marker when present. */
export function stripSilentFeedbackTypesSubmissionMarker(message: string): string {
  return isSilentFeedbackTypesPickerSubmission(message)
    ? message.slice(SILENT_FEEDBACK_TYPES_SUBMISSION_MARKER.length)
    : message;
}

const FEEDBACK_TYPE_CUSTOM_LABEL_SUFFIX = /\s*\((?:custom)\)\s*$/i;

export function questionIsFeedbackTypesPicker(questionText: string): boolean {
  return (questionText?.trimStart() ?? "").startsWith(QUESTION_FEEDBACK_TYPES_PREFIX);
}

export function feedbackTypePluginNamesFromMultiSelectAnswer(answer: string): string[] {
  const parts = answer
    .split(",")
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
  return parts.map((segment) => segment.replace(FEEDBACK_TYPE_CUSTOM_LABEL_SUFFIX, "").trim()).filter(Boolean);
}
